import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';

const BannerProvider = (props) => {
  const api = new API();
  const [bannerTableFilter, setBannerTableFilter] = useState({
    page: 1,
    limit: 20,
    search: "",
  });
  const [bannerList, setBannerList] = useState([]);
  const [bannerListLoader, setBannerListLoader] = useState(false);
  const [bannerCreateForm] = Form.useForm();
  const [bannerCreateLoader, setBannerCreateLoader] = useState(false);
  
  const [bannerCategoryList, setBannerCategoryList] = useState([]);
  const [bannerSubCategoryList, setBannerSubCategoryList] = useState([]);
  
  const [bannerContentList, setBannerContentList] = useState([]);
  const [bannerContentLoader, setBannerContentLoader] = useState(false);

  const fetchBannerList = async () => {
    setBannerListLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("banner", { ...bannerTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setBannerList(res?.data?.data);
        } else {
          setBannerList([]);
        }
        setBannerListLoader(false);
      }));
  }

  const createBanner = async (data, navigate) => {
    setBannerCreateLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("banner", data, (err, res) => {
        if (res?.data?.status === 200) {
          bannerCreateForm.resetFields();
          navigate("/banner_list");
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message || "Something went wrong");
        }
        setBannerCreateLoader(false);
      }));
  }

  const updateBanner = async (id, data, navigate) => {
    setBannerCreateLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("banner", id, data, (err, res) => {
        if (res?.data?.status === 200) {
          bannerCreateForm.resetFields();
          navigate("/banner_list");
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message || "Something went wrong");
        }
        setBannerCreateLoader(false);
      }));
  }

  const deleteBanner = async (id) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.remove("banner", id, (err, res) => {
        if (res?.data?.status === 200) {
          fetchBannerList();
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message || "Something went wrong");
        }
      }));
  }

  const updateBannerStatus = async (id, status) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("banner/status", id, { status }, (err, res) => {
        if (res?.data?.status === 200) {
          fetchBannerList();
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message || "Something went wrong");
        }
      }));
  }

  const updateBannerLimited = async (id, is_limited) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("banner/limited", id, { is_limited }, (err, res) => {
        if (res?.data?.status === 200) {
          fetchBannerList();
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message || "Something went wrong");
        }
      }));
  }

  const fetchCategoryList = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll("pushnotification/get_category_list", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setBannerCategoryList(res?.data?.data);
        }
      }));
  }

  const fetchSubCategoryList = async (categories) => {
    if (!categories || categories.length === 0) {
      setBannerSubCategoryList([]);
      return;
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.create("pushnotification/get_subcategory_list_multi", {
        all_category: categories
      }, (err, res) => {
        if (res?.data?.status === 200) {
          setBannerSubCategoryList(res?.data?.data);
        }
      }));
  }

  const fetchContentList = async (type) => {
    if (!type || type === "none" || type === "url" || type === "subscription") {
        setBannerContentList([]);
        return;
    }
    let url = "";
    if (type === "qbank") url = "pushnotification/get_qbank_list";
    if (type === "videos") url = "pushnotification/get_video_list";
    if (type === "pearls") url = "pushnotification/get_pearls_list";
    if (type === "updates") url = "pushnotification/get_updates_list";
    if (type === "testseries") url = "pushnotification/get_testseries_list";
    if (type === "dnbmd") url = "pushnotification/get_dnbmd_list";

    setBannerContentLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.getAll(url, {}, (err, res) => {
        if (res?.data?.status === 200) {
          setBannerContentList(res?.data?.data);
        } else {
          setBannerContentList([]);
        }
        setBannerContentLoader(false);
      }));
  }

  return (
    <Context.Provider value={{
      ...props,
      bannerList, setBannerList,
      bannerListLoader, setBannerListLoader,
      bannerTableFilter, setBannerTableFilter,
      bannerCreateForm,
      bannerCreateLoader, setBannerCreateLoader,
      fetchBannerList,
      createBanner,
      updateBanner,
      deleteBanner,
      updateBannerStatus,
      updateBannerLimited,
      bannerCategoryList,
      fetchCategoryList,
      bannerSubCategoryList,
      fetchSubCategoryList,
      bannerContentList,
      bannerContentLoader,
      fetchContentList
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default BannerProvider;
